<template>
  <section class="serverManage">
    <!--头部开始-->
    <v-login-info></v-login-info>
    <!--头部结束-->

    <div class="server-manage-content">
      <h3 class="server-name">服务器名字：{{ serverInfo.ServerName }}</h3>

      <div class="server-manage-info">
        <p class="server-desc">服务器信息</p>

        <ul class="server-info-list">
          <li class="list-item">
            <span class="text-item">服务器SID：{{ serverInfo.ServerId }}</span>
            <span class="text-item">服务器状态：{{ serverInfo.ServerStatus }}</span>
          </li>

          <li class="list-item">
            <span class="text-item">服务器模式：{{ modTypeText }}</span>
            <span class="text-item">服务器套餐：{{ serverInfo.ServerType }}</span>
          </li>

          <li class="list-item">
            <span class="text-item">服务器密码：{{ serverInfo.PassWord ? serverInfo.PassWord : '无' }}</span>
            <span class="text-item">是否公开：{{ serverInfo.IsShow ? '是' : '否' }}</span>
          </li>
        </ul>

        <p class="operate-info">运营数据</p>

        <ul class="operate-info-list">
          <li class="list-item">
            <span class="text-item operate-item">开放截止时间：{{ serverInfo.EndTime }}</span>
            <span class="text-item">在线人数：{{serverInfo.PlayerNum}}/{{serverInfo.MaxPlayerNum}}</span>
          </li>

          <!--<li class="list-item">
            <span class="text-item operate-item">创建角色：3231个</span>
            <span class="text-item">家园数量：500</span>
          </li>-->
        </ul>

        <div class="handle">
          <a class="btn-item" href="javascript: void(0)" @click="setupFn">设置</a>
          <!--升级 / 扩容-->
          <a class="btn-item" href="javascript: void(0)" @click="expandFn">{{ expandBtnText }}</a>
          <a class="btn-item" href="javascript: void(0)" @click="renewFn">续费</a>
          <a class="btn-item" href="javascript: void(0)" @click="blackFn">黑名单</a>
        </div>
      </div>
    </div>

    <!--遮罩层开始-->
    <div class="handle-mask-wrap" onselectstart="return false">
      <transition name="fade">
        <div class="confirm-mask" v-show="show">
          <div class="confirm-mask-content" ref="confirmMaskContent">
            <!--服务器设置开始-->
            <form v-show="setupFlag" class="self-server-setup" action="javascript: void(0)">
              <!--密码设置-->
              <dl class="form-item clearfix">
                <dt class="item-title">密码设置：</dt>
                <dd class="item-content">
                  <div class="radio-item">
                    <span class="base-radio-box">
                      <input id="noPwd" name="pwd" class="base-radio" type="radio" value="false" v-model="isServerPwd" v-validate="'required'" />
                      <label class="icon-box" for="noPwd">
                        <i class="icon icon-radio-unchecked"></i>
                      </label>
                    </span>
                    <span class="text">无密码</span>
                  </div>

                  <div class="radio-item">
                    <span class="base-radio-box">
                      <input id="hasPwd" name="pwd" class="base-radio" type="radio" value="true" v-model="isServerPwd" v-validate="'required'" />
                      <label class="icon-box" for="hasPwd">
                        <i class="icon icon-radio-unchecked"></i>
                      </label>
                    </span>

                    <span class="text">有密码</span>

                    <span>
                      <input class="server-pwd" type="password" v-model="serverPwd" />
                    </span>
                  </div>
                </dd>
              </dl>

              <dl class="form-item clearfix">
                <dt class="item-title">公开房间列表：</dt>
                <dd class="item-content">
                  <div class="radio-item radio-inline">
                    <span class="base-radio-box">
                      <input id="pub" name="rootList" class="base-radio" type="radio" value="true" v-model="isPublic" v-validate="'required'" />
                      <label class="icon-box" for="pub">
                        <i class="icon icon-radio-unchecked"></i>
                      </label>
                    </span>
                    <span class="text">公开</span>
                  </div>

                  <div class="radio-item radio-inline">
                    <span class="base-radio-box">
                      <input id="noPub" name="rootList" class="base-radio" type="radio" value="false" v-model="isPublic" v-validate="'required'" />
                      <label class="icon-box" for="noPub">
                        <i class="icon icon-radio-unchecked"></i>
                      </label>
                    </span>
                    <span class="text">不公开</span>
                  </div>
                </dd>
              </dl>

              <div class="handle">
                <a class="btn" href="javascript: void(0)" @click="setupCancelFn">取消</a>
                <a class="btn sub" href="javascript: void(0)" @click="setupSaveFn">提交</a>
              </div>
            </form>
            <!--服务器设置结束-->

            <!--服务器扩容/降级开始-->
            <form class="expand" v-show="expandFlag" action="javascript: void(0)">

              <h3 class="expand-title">服务器切换</h3>

              <p class="expand-desc">切换后，10天内不得在进行次操作</p>

              <ul class="expand-list clearfix">
                <li class="li-item clearfix" v-for="(item, index) in expandListSort">
                  <div class="item" href="javascript: void(0)" :class="{ active : item.id === expandInfo.ServerType }">
                    <span class="text">{{ item.name }}</span>
                    <span class="text">最多同时在线{{ item.player }}人</span>
                  </div>
                </li>
              </ul>

              <ul class="expand-info-list">
                <li class="item">上次操作时间 {{ expandInfo.OprateTime }}</li>
                <li class="item">当前剩余时间 {{ expandInfo.DaysRemaining }} 天</li>
                <li class="item">切换后剩余时间 {{ expandToggleTime }} 天</li>
              </ul>

              <div class="handle">
                <a class="btn" href="javascript: void(0)" @click="expandCancelFn">取消</a>
                <a class="btn" :class="expandInfo.CanEnlarge ? 'active' : '' " href="javascript: void(0)" @click="expandToggleFn">切换</a>
              </div>
            </form>
            <!--服务器扩容/降级结束-->

            <!--服务器续费开始-->
            <form class="renew" v-show="renewFlag" action="javascript: void(0)">
              <h3 class="renew-title">服务器续费</h3>

              <div class="ticket-info">
                <span class="ticket-info-item" v-show="countTicket(3)">小型服务器3个月续费券 {{ countTicket(3) }} 张</span>
                <span class="ticket-info-item" v-show="countTicket(4)">小型服务器6个月续费券 {{ countTicket(4) }} 张</span>
                <span class="ticket-info-item" v-show="countTicket(5)">中型服务器3个月续费券 {{ countTicket(5) }} 张</span>
                <span class="ticket-info-item" v-show="countTicket(6)">中型服务器6个月续费券 {{ countTicket(6) }} 张</span>
              </div>

              <h3 class="ticket-list-title">续费卷</h3>

              <ul class="ticket-list">
                <li class="item clearfix" v-for="(item, index) in ticketList">
                  <span class="base-radio-box">
                    <input :id="`item${index}`" name="pwd" class="base-radio" type="radio" :value="item.Id" v-model="ticketId" v-validate="'required'" />
                    <label class="icon-box" :for="`item${index}`">
                      <i class="icon icon-radio-unchecked"></i>
                    </label>
                  </span>

                  <span class="text">{{ ticketInfo[item.Type].name }}</span>
                </li>
              </ul>

              <div class="handle">
                <a class="btn" href="javascript: void(0)" @click="renewCancelFn">取消</a>
                <a class="btn sub" v-show="ticketList.length" href="javascript: void(0)" @click="renewSubFn">提交</a>
              </div>
            </form>
            <!--服务器续费结束-->

            <!--黑名单开始-->
            <form class="black-menu" action="javascript: void(0)" v-show="blackFlag">
              <h3 class="black-title clearfix">
                <span class="left">添加黑名单</span>
                <a class="right" href="javascript: void(0)" @click="blackCancelFn">
                  <i class=" icon icon-cancel-circle"></i>
                </a>
              </h3>

              <!--查询开始-->
              <div class="conent">
                <input class="black-input" name="black" type="text" value="searchName" v-model="searchName"/>
                <a class="black-search" href="javascript: void(0)" @click="blackSearchFn">查询</a>
              </div>
              <!--查询结束-->

              <div v-show="searchInfo" class="black-list">
                <div class="list-item">
                  <span class="title">{{ searchInfo.RoleName }}</span>
                  <span class="content">
                    <a class="btn" href="javascript: void(0)" @click="addBlackFn(searchInfo.Id)">添加</a>
                  </span>
                </div>
              </div>

              <!--黑名单列表开始-->
              <ul v-show="blackList.length" class="black-list">
                <li class="list-item">
                  <span class="title">角色名</span>
                  <span class="content">操作</span>
                </li>

                <li v-for="(item, index) in blackList" class="list-item">
                  <span class="title">{{ item.RoleName }}</span>
                  <span class="content">
                    <a class="btn" href="javascript: void(0)" @click="delBlackFn(item.Id, index)">删除</a>
                  </span>
                </li>
              </ul>
              <!--黑名单列表结束-->
            </form>
            <!--黑名单结束-->
          </div>
        </div>
      </transition>
    </div>
    <!--遮罩层结束-->

    <!--确认删除层开始-->
    <div class="confirm-mask-wrap" onselectstart="return false">
      <transition name="fade">
        <div class="confirm-mask" v-show="confirmFlag">
          <div class="confirm-mask-content" ref="confirmMaskContent">
            <p class="desc">请确认您的操作</p>

            <div class="btn-wrap">
              <a class="btn cancel" href="javascript: void(0)" @click="closeMaskFn">取消</a>
              <a class="btn revoke" href="javascript: void(0)" @click="delBlackConfirmFn">删除</a>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!--确认删除层结束-->

    <!--提示层-->
    <v-basic-mask :show="tipsShow" @closeMaskEv="closeMaskEvFn">
      <span slot="desc">{{ tipsText }}</span>
    </v-basic-mask>
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  // 基础弹出层组件
  import basicMask from 'components/basicMask/basicMask'
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // 错误信息
  const ERROR_TIPS = [
    { desc: '查询角色名称不能为空' },
    { desc: '删除成功' }
  ]

  export default {
    // 服务器管理
    name: 'serverManage',
    data () {
      return {
        // 服务器模式
        modType: '',
        // 要查找的黑名单名字
        searchName: '',
        // 黑名单查询到的信息
        searchInfo: '',
        // 提示层开关
        tipsShow: false,
        // 提示信息
        tipsText: '',
        // 是否刷新页面
        refreshFlag: false,
        // 确认删除弹出层
        confirmFlag: false,
        // 要删除黑名单的id
        delBlackId: '',
        // 要删除黑名单的索引
        delBlackIndex: '',
        // 遮罩层开关
        show: false,
        // 服务器设置开关
        setupFlag: false,
        // 扩容开关
        expandFlag: false,
        // 私服能否扩容信息
        expandInfo: '',
        // 扩容服务器列表
        expandList: [
          {
            id: 1,
            name: '小型服务器',
            player: 12
          },
          {
            id: 2,
            name: '中型服务器',
            player: 24
          }
        ],
        // 续费开关
        renewFlag: false,
        // 续费卷列表
        ticketList: [],
        // 所有的续费卷
        totalTicketList: [],
        // 续费卷id
        ticketId: '',
        // 开服卷描述列表
        ticketInfo: [
          {
            id: 0,
            name: '无',
            desc: '无'
          },
          {
            id: 1,
            name: '小型服务器开服券',
            desc: '小型服务器开服券'
          },
          {
            id: 2,
            name: '小型服务器开服券',
            desc: '小型服务器开服券'
          },
          {
            id: 3,
            name: '续费卷-小型服务器1个月',
            desc: '免费续费可同时在线12人的小型服务器1个月'
          },
          {
            id: 4,
            name: '续费卷-小型服务器6个月',
            desc: '免费续费可同时在线12人的小型服务器6个月'
          },
          {
            id: 5,
            name: '续费卷-中型服务器1个月',
            desc: '免费续费可同时在线50人的小型服务器1个月'
          },
          {
            id: 6,
            name: '续费卷-中型服务器6个月',
            desc: '免费续费可同时在线50人的小型服务器6个月'
          }
        ],
        // 服务器密码
        serverPwd: '',
        // 服务器是否有密码
        isServerPwd: '',
        // 是否公开房间列表
        isPublic: '',
        // 服务器信息
        serverInfo: '',
        // 黑名单标志
        blackFlag: false,
        // 黑名单数据列表
        blackList: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID')
        }
      }
    },
    computed: {
      // 服务器模式文本信息
      modTypeText () {
        if (this.modType === 0) {
          return '和平模式'
        } else {
          return '混战模式'
        }
      },
      // 当前服务器类型对应的列表索引
      expandIndex () {
        return this.expandInfo.ServerType - 1
      },
      // 当前服务器类型
      serverType () {
        switch (this.serverInfo.MaxPlayerNum) {
          case 12:
            return 1
          case 50:
            return 2
          default:
            return 1
        }
      },
      // 重新排列数组
      expandListSort () {
        this.expandList.forEach((item, index) => {
          if (parseInt(this.expandInfo.ServerType) === parseInt(item.id)) {
            this.expandList.unshift(this.expandList.splice(index, 1)[0])
          }
        })
        return this.expandList
      },
      // 扩容/降级文字
      expandBtnText () {
        switch (this.serverType) {
          case 1:
            return '扩容'
          case 2:
            return '降级'
          default:
            return ''
        }
      },
      // 切换后剩余时间
      expandToggleTime () {
        switch (this.expandInfo.ServerType) {
          case 1:
            return parseInt(this.expandInfo.DaysRemaining / 3)
          case 2:
            return parseInt(this.expandInfo.DaysRemaining * 3)
          default:
            return parseInt(this.expandInfo.DaysRemaining / 3)
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 查询创建的服务器 api
        Axios.post(`${this.$api.root}/PersonalRoom/GetPersonalRoomInfo`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 获取私服信息
                this.serverInfo = res.ServerInfo
                // 获取服务器密码
                this.serverPwd = this.serverInfo.PassWord
                // 获取是否公开服务器至房间列表标记
                this.isPublic = this.serverInfo.IsShow
                // 服务器模式 0 和平 1 PVP
                this.modType = this.serverInfo.PvpType
                // 如果有密码设置标记
                if (this.serverPwd !== null && this.serverPwd !== '') {
                  this.isServerPwd = true
                // 没有密码设置标记
                } else {
                  this.isServerPwd = false
                }
                break
              case 1:
                // 删除用户信息
                delUserCookie()
                // 跳转到登录页
                this.$router.push({name: 'login'})
                break
              case 2:
                this.tipsShow = true
                this.tipsText = res.Msg
                break
              default:
                this.tipsShow = true
                this.tipsText = res.Msg
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 服务器设置
      setupFn () {
        // 显示弹出层
        this.show = true
        // 显示服务器设置表单
        this.setupFlag = true
      },
      // 保存服务器设置
      setupSaveFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 初始化密码
        let passWord = ''
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 将服务器 id 添加到表单
        formData.append('ServerId', this.serverInfo.ServerId)
        // 是否将服务器公开房间至列表
        formData.append('ListShow', this.isPublic)
        // 如果有设置密码
        if (this.isServerPwd === 'true') {
          passWord = this.serverPwd
        } else {
          passWord = ''
        }
        // 将密码添加到表单
        formData.append('PassWord', passWord)

        // 保存服务器设置 api
        Axios.post(`${this.$api.root}/PersonalRoom/EditPersonalRoomInfo`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 打开提示层
                this.tipsShow = true
                // 提示内容
                this.tipsText = '修改成功'
                // 刷新页面
                this.refreshFlag = true
                // 关闭服务器设置
                this.setupFlag = false
                break
              case 1:
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              default:
                console.log(res.Msg)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 服务器设置取消
      setupCancelFn () {
        this.show = false
        this.setupFlag = false
      },
      // 服务器扩容
      expandFn () {
        // 打开遮罩层
        this.show = true
        // 打开私服扩容表单
        this.expandFlag = true
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 将服务器 id 添加到表单
        formData.append('ServerId', this.serverInfo.ServerId)

        // 私服是否可以切换 api
        Axios.post(`${this.$api.root}/PersonalRoom/PersonalRoomEnlargeInfo`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 获取服务器切换信息
                this.expandInfo = res
                break
              case 1:
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              case 2:
                this.tipsShow = true
                this.tipsText = res.Msg
                break
              default:
                this.tipsShow = true
                this.tipsText = res.Msg
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 服务器扩容取消关闭
      expandCancelFn () {
        // 关闭遮罩层
        this.show = false
        // 关闭服务器扩容
        this.expandFlag = false
      },
      // 切换服务器
      expandToggleFn () {
        if (this.expandInfo.CanEnlarge) {
          // 实例化表单对象
          let formData = new FormData()
          // 将用户id添加到表单
          formData.append('UserID', this.formDatas.userId)
          // 将session id 添加到表单
          formData.append('SessionID', this.formDatas.sessionId)
          // 将服务器 id 添加到表单
          formData.append('ServerId', this.serverInfo.ServerId)

          // 私服是否可以切换 api
          Axios.post(`${this.$api.root}/PersonalRoom/PersonalRoomEnlarge`, formData, {
            // 设置请求为表单提交
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((response) => {
            // http 请求成功
            if (response.status === 200) {
              // 获取接口数据
              let res = response.data
              switch (res.Code) {
                case 0:
                  let serverTYpe = ''
                  switch (res.ServerType) {
                    case 1:
                      serverTYpe = '小型服务器'
                      break
                    case 2:
                      serverTYpe = '中型服务器'
                      break
                    default:
                      serverTYpe = '切换异常'
                  }

                  // 打开提示层
                  this.tipsShow = true
                  // 提示信息
                  this.tipsText = `服务器已转换为${serverTYpe}`
                  // 开启刷新页面
                  this.refreshFlag = true
                  break
                case 1:
                  delUserCookie()
                  this.$router.push({name: 'login'})
                  break
                case 2:
                  this.tipsShow = true
                  this.tipsText = res.Msg
                  break
                default:
                  // 打开提示层
                  this.tipsShow = true
                  // 提示信息
                  this.tipsText = `服务器已转换为${serverTYpe}`
              }
            }
          }).catch((error) => {
            console.log(error)
          })
        } else {
          // 获取当前时间戳
          let nowTimeStamp = Date.parse(new Date())
          // 获取最后操作时间对象
          let lastTime = new Date(this.expandInfo.OprateTime)
          // 到期时间，最后操作时间的后10天时间戳
          let overdueTime = lastTime.setDate(lastTime.getDate() + 10)
          // 如果当前时间小于到期时间
          if (overdueTime > nowTimeStamp) {
            // 获取当前时间距离过期时间的天数
            let surplusDays = Math.round((overdueTime - nowTimeStamp) / 86400000)
            // 打开提示层
            this.tipsShow = true
            // 提示错误
            this.tipsText = `切换服务器后，10天内不能再切换，剩余${surplusDays}天`
          }
        }
      },
      // 续费
      renewFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 将服务器 id 添加到表单
        formData.append('ServerId', this.serverInfo.ServerId)
        // 隐藏页面滚动条
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
        // 私服续费初始化接口 api
        Axios.post(`${this.$api.root}/PersonalRoom/PersonalRoomDeferInfo`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 打开遮罩层
                this.show = true
                // 打开续费表单
                this.renewFlag = true
                // 将小型和中型开发卷合并到一个数组
                let newArr = res.Ticket_OneMonthList.concat(res.Ticket_SixMonthList)
                this.totalTicketList = newArr
                // 将合并后的开服卷列表赋值到对象属性
                switch (res.ServerType) {
                  case 1:
                    this.ticketList = res.Ticket_OneMonthList
                    break
                  case 2:
                    this.ticketList = res.Ticket_SixMonthList
                    break
                  default:
                    this.ticketList = res.Ticket_OneMonthList
                }
                break
              case 1:
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              case 2:
                this.tipsShow = true
                this.tipsText = res.Msg
                break
              default:
                this.tipsShow = true
                this.tipsText = res.Msg
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 取消续费
      renewCancelFn () {
        // 打开遮罩层
        this.show = false
        // 打开续费表单
        this.renewFlag = false
        // 清空开服卷
        this.ticketId = ''
        // 显示页面滚动条
        document.getElementsByTagName('body')[0].style.overflow = 'auto'
      },
      // 提交续费
      renewSubFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 将服务器 id 添加到表单
        formData.append('ServerId', this.serverInfo.ServerId)
        // 续费卷id
        formData.append('TicketIds', this.ticketId)

        if (this.ticketId === '') {
          // 打开提示层
          this.tipsShow = true
          // 提示错误
          this.tipsText = '请选择开服卷'
        } else {
          // 私服续费 api
          Axios.post(`${this.$api.root}/PersonalRoom/PersonalRoomDefer`, formData, {
            // 设置请求为表单提交
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((response) => {
            // http 请求成功
            if (response.status === 200) {
              // 获取接口数据
              let res = response.data
              switch (res.Code) {
                case 0:
                  // 关闭续费表单
                  this.renewFlag = false
                  // 清空续费卷id
                  this.ticketId = ''
                  // 打开提示层
                  this.tipsShow = true
                  // 提示错误
                  this.tipsText = '续费成功'
                  // 刷新页面
                  this.refreshFlag = true
                  break
                case 1:
                  delUserCookie()
                  this.$router.push({name: 'login'})
                  break
                case 2:
                  this.tipsShow = true
                  this.tipsText = res.Msg
                  break
                default:
                  this.tipsShow = true
                  this.tipsText = res.Msg
              }
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      },
      // 计算续费卷个数
      countTicket (index) {
        let arr = []
        this.totalTicketList.forEach((item) => {
          if (parseInt(index) === parseInt(item.Type)) {
            arr.push(item)
          }
        })
        return arr.length
      },
      // 获取黑名单列表
      getBlackFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 黑名单列表 api
        Axios.post(`${this.$api.root}/BlackList/GetBlackList_New`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                this.blackList = res.ItemList
                break
              case 1:
                // 删除用户信息
                delUserCookie()
                // 跳转到登录页
                this.$router.push({name: 'login'})
                break
              case 2:
                this.tipsShow = true
                this.tipsText = res.Msg
                break
              default:
                this.tipsShow = true
                this.tipsText = res.Msg
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 黑名单
      blackFn () {
        // 打开遮罩层
        this.show = true
        // 打开黑名单设置
        this.blackFlag = true
        // 获取黑名单列表
        this.getBlackFn()
      },
      // 添加到黑名单
      addBlackFn (id) {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 角色 id
        formData.append('RoleId', id)
        // 黑名角色查找 api
        Axios.post(`${this.$api.root}/BlackList/AddBlackList_New`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 获取黑名单列表
                this.getBlackFn()
                // 弹出提示信息
                this.tipsShow = true
                this.tipsText = res.Msg
                // 清空查询到的黑名单信息
                this.searchInfo = ''
                break
              case 1:
                // 删除用户信息
                delUserCookie()
                // 跳转到登录页
                this.$router.push({name: 'login'})
                break
              case 2:
                this.tipsShow = true
                this.tipsText = res.Msg
                break
              default:
                this.tipsShow = true
                this.tipsText = res.Msg
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 黑名单查询
      blackSearchFn () {
        // 如果输入了内容
        if (this.searchName.trim()) {
          // 实例化表单对象
          let formData = new FormData()
          // 将用户id添加到表单
          formData.append('UserID', this.formDatas.userId)
          // 将session id 添加到表单
          formData.append('SessionID', this.formDatas.sessionId)
          // 私服 id
          formData.append('ServerId', this.serverInfo.ServerId)
          // 角色名
          formData.append('RoleName', this.searchName)
          // 黑名角色查找 api
          Axios.post(`${this.$api.root}/BlackList/SearchRole_New`, formData, {
            // 设置请求为表单提交
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((response) => {
            // http 请求成功
            if (response.status === 200) {
              // 获取接口数据
              let res = response.data
              switch (res.Code) {
                case 0:
                  // 清空输入框查询内容
                  this.searchName = ''
                  // 获取查询到的信息
                  this.searchInfo = res
                  // console.log(this.searchInfo)
                  break
                case 1:
                  // 删除用户信息
                  delUserCookie()
                  // 跳转到登录页
                  this.$router.push({name: 'login'})
                  break
                case 2:
                  this.tipsShow = true
                  this.tipsText = res.Msg
                  break
                default:
                  this.tipsShow = true
                  this.tipsText = res.Msg
              }
            }
          }).catch((error) => {
            console.log(error)
          })
        } else {
          // 打开提示层
          this.tipsShow = true
          // 提示错误
          this.tipsText = ERROR_TIPS[0].desc
        }
      },
      // 取消黑名单
      blackCancelFn () {
        // 打开遮罩层
        this.show = false
        // 打开黑名单设置
        this.blackFlag = false
      },
      // 关闭提示层
      closeMaskEvFn (val) {
        console.log(val)
        // 关闭弹出层
        this.tipsShow = val
        // 是否刷新页面
        if (this.refreshFlag) {
          // 重置刷新标志
          this.refreshFlag = false
          // 刷新页面
          // this.$router.go(0)
          // 更新数据
          this.init()
        }
        // 关闭操作界面
        this.show = !this.show
      },
      // 关闭确认删除弹出层
      closeMaskFn () {
        this.confirmFlag = false
      },
      // 删除黑名单
      delBlackFn (id, index) {
        // 打开确认删除弹层
        this.confirmFlag = true
        // 记录要删除的黑名单 id
        this.delBlackId = id
        // 记录要删除黑名单的索引
        this.delBlackIndex = index
      },
      // 确认删除黑名单
      delBlackConfirmFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 角色 id
        formData.append('Id', this.delBlackId)
        // 黑名角色查找 api
        Axios.post(`${this.$api.root}/BlackList/DeleteBlackList_New`, formData, {
          // 设置删除黑名单
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 关闭确认删除弹出层
                this.confirmFlag = false
                // 打开提示弹出层
                this.tipsShow = true
                // 提示信息
                this.tipsText = this.tipsText = ERROR_TIPS[1].desc
                // 删除数组中对应的元素
                this.blackList.splice(this.delBlackIndex, 1)
                // 清空删除 id
                this.delBlackId = ''
                // 清空删除索引
                this.delBlackIndex = ''
                break
              case 1:
                // 删除用户信息
                delUserCookie()
                // 跳转到登录页
                this.$router.push({name: 'login'})
                break
              case 2:
                this.tipsShow = true
                this.tipsText = res.Msg
                break
              default:
                this.tipsShow = true
                this.tipsText = res.Msg
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    components: {
      'v-login-info': loginInfo,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "serverManage.styl";
  @import "../../assets/stylus/checkbox.styl";
  @import '../../assets/stylus/radio.styl';
</style>



// WEBPACK FOOTER //
// src/views/serverManage/serverManage.vue